import { Control, useController } from 'react-hook-form';
import Checkbox from '@components/common/checkbox';
import ErrorMessage from '@components/profile/profileOverlay/common/ErrorMessage';
import { AdditionInfoVO } from '@domain/vo/match/ResumeAdditionInfoVO';

import classnames from 'classnames/bind';
import styles from './additionalInputModal.module.scss';
const cx = classnames.bind(styles);

interface Props extends AdditionInfoVO {
  control: Control;
}

const MultiChoice = ({ required, choices, additionInfoSn, question, control }: Props) => {
  const {
    field,
    fieldState: { invalid },
    formState: { errors },
  } = useController({
    control,
    name: `${additionInfoSn}`,
    defaultValue: [] as string[],
  });

  const handleChange = (value: string) => {
    const values = Array.isArray(field.value) ? field.value : [field.value];
    if (values.includes(value)) {
      // 제거
      field.onChange(values.filter((v) => v !== value));
    } else {
      // 추가
      field.onChange([...values, value]);
    }
  };

  return (
    <div>
      <h3 className={cx('formTitle')}>
        {question}
        <span className={cx('formSubTitle')}>(복수 선택)</span>
        {required && <span className={cx('require')}>필수</span>}
      </h3>

      <div className={cx('checkboxWrap')}>
        {choices.map((choice) => (
          <Checkbox
            key={choice}
            className={cx('checkbox')}
            checked={(field.value ?? []).includes(choice)}
            value={choice}
            onChange={() => handleChange(choice)}
            name={field.name}
            type="square"
          >
            {choice}
          </Checkbox>
        ))}
      </div>

      {invalid && <ErrorMessage errors={errors} name={field.name} />}
    </div>
  );
};

export default MultiChoice;
